import { Events } from 'src/constants/webSocketConsts/events';
import {
  deleteInvoicesAction,
  updateInvoicesAction,
} from 'src/store/payments/actions';
import { ensureUnreachable } from 'src/utils/common_utils';

const invoiceLegacyHandler = (event: Events, items: Array<any>) => {
  if (items.length === 0) {
    return null;
  }
  switch (event) {
    case Events.Remove:
      return deleteInvoicesAction(items);
    case Events.Insert:
    case Events.Modify:
      return updateInvoicesAction(items);
    case Events.DomainVerified:
    case Events.Refresh:
      return null;
    default:
      return ensureUnreachable(event);
  }
};

export default invoiceLegacyHandler;
